import React from "react";
import PropTypes from "prop-types";
import { loginTexts } from "../../locales/en";

const EmailField = ({ value, error, onChange, disabled, label }) => (
  <div className="input-row">
    <div className="input-group">
      <label htmlFor="email">{label}</label>

      <input
        id="email"
        name="email"
        type="email"
        placeholder={loginTexts.emailPlaceholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        disabled={disabled}
        autoComplete="true"
      />

      {error && (
        <p className="error-message">
          <small>{error}</small>
        </p>
      )}
    </div>
  </div>
);

export default EmailField;

EmailField.propTypes = {
  value: PropTypes.string,
  error: PropTypes.string,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  label: PropTypes.string
};
